import { render, staticRenderFns } from "./PdvDashboard.vue?vue&type=template&id=cfef2432&scoped=true"
import script from "./PdvDashboard.vue?vue&type=script&lang=js"
export * from "./PdvDashboard.vue?vue&type=script&lang=js"
import style0 from "./PdvDashboard.vue?vue&type=style&index=0&id=cfef2432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfef2432",
  null
  
)

export default component.exports